/**
 * Validates a redirect target to prevent open redirects.
 * Allows relative paths (single leading slash) or same-origin absolute URLs.
 */
export function sanitizeRedirectUrl(url: string | null | undefined, origin: string, fallback = "/"): string {
  if (!url || !url.trim()) return fallback;

  const trimmed = url.trim();

  if (trimmed.startsWith("/") && !trimmed.startsWith("//")) {
    return trimmed;
  }

  try {
    const parsed = new URL(trimmed, origin);
    if (parsed.origin === origin) {
      return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    }
  } catch {
    // fall through to fallback
  }

  return fallback;
}
